import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';

import DeleteIcon from '@material-ui/icons/Delete';

import {
  startRemoveTaskLaborItem,
  startRemoveTaskMaterialsItem
} from 'store/actions/bids';

import { startEditBidEditorState } from '../../../../store/actions/bidEditor';
import TaskItem from './TaskItem';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  button: {
    margin: theme.spacing.unit,
  },
  mainCell: {
    width: '100%'
  },
  white: {
    color: '#fff',
  },
});

class TaskTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showItem: undefined,
      selectedItem: undefined,
    }
  }

  handleEditOpen = () => {
    this.setState({showItem: "edit"});
  };

  handleAddOpen = () => {
    const { startEditBidEditorState } = this.props;
    const { type } = this.props;

    type.toLowerCase() === 'labor'
      ? startEditBidEditorState("jobTasksAddItemLabor")
      : startEditBidEditorState("jobTasksAddItemMaterials");

    this.setState({showItem: "add"});
  };

  handleClose = () => {
    this.setState({
      showItem: undefined,
      selectedItem: undefined,
    });
  };

  render() {
    const {
      classes,
      type,
      bidTask,
      preview,
      startRemoveTaskLaborItem,
      startRemoveTaskMaterialsItem
    } = this.props;
    const { showItem, selectedItem } = this.state
    const items = type.toLowerCase() === 'labor'
      ? bidTask.labor
      : bidTask.materials;

    return(
      <div className={classes.root}>
        <TaskItem
          showItem={showItem}
          bidTask={bidTask}
          item={selectedItem}
          type={type}
          handleClose={this.handleClose}
        />
      <Table>
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableCell} padding="dense" variant="head">Description</TableCell>
              <TableCell className={classes.tableCell} padding="dense" variant="head" numeric>Qty</TableCell>
              <TableCell className={classes.tableCell} padding="dense" variant="head" numeric>Rate</TableCell>
              <TableCell className={classes.tableCell} padding="dense" variant="head" numeric>Markup</TableCell>
              <TableCell className={classes.tableCell} padding="dense" variant="head" numeric>Total</TableCell>
              <TableCell padding="none" variant="head" />
            </TableRow>
          </TableHead>

          <TableBody>
            {items.map((item) => {
              return(
                <TableRow
                  hover
                  key={item.id}
                  style={{cursor: 'pointer'}}
                >
                  <TableCell
                    padding="dense"
                    variant="body"
                    onClick={() => this.setState({showItem: "edit", selectedItem: item})}
                    >
                    <Typography className={classes.white}>{item.description}</Typography>
                  </TableCell>
                  <TableCell
                    padding="dense"
                    variant="body"
                    numeric
                    onClick={() => this.setState({showItem: "edit", selectedItem: item})}
                    >
                    <Typography className={classes.white}>{item.quantity}</Typography>
                  </TableCell>
                  <TableCell
                    padding="dense"
                    variant="body"
                    numeric
                    onClick={() => this.setState({showItem: "edit", selectedItem: item})}
                    >
                    <Typography className={classes.white}>${item.rate.toFixed(2)}</Typography>
                  </TableCell>
                  <TableCell
                    padding="dense"
                    variant="body"
                    numeric
                    onClick={() => this.setState({showItem: "edit", selectedItem: item})}
                    >
                    <Typography className={classes.white}>{item.markup}%</Typography>
                  </TableCell>
                  <TableCell
                    padding="dense"
                    variant="body"
                    numeric
                    onClick={() => this.setState({showItem: "edit", selectedItem: item})}
                    >
                    <Typography className={classes.white}>${item.total.toFixed(2)}</Typography>
                  </TableCell>
                  <TableCell padding="none" variant="body" numeric>
                    <Button
                      aria-label="delete"
                      size="small"
                      className={classes.deleteButton}
                      onClick={() => {
                        if (type.toLowerCase() === "labor") {
                          startRemoveTaskLaborItem(bidTask.id, item.id)
                        } else if (type.toLowerCase() === "materials") {
                          startRemoveTaskMaterialsItem(bidTask.id, item.id)
                        }
                      }}
                      style={{color: '#fff'}}
                      >
                      <DeleteIcon />
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {!preview &&
          <Button
            color="default"
            className={classes.button}
            onClick={this.handleAddOpen}

          >
            Add Item
          </Button>
        }
      </div>
    );
  }
}

TaskTable.propTypes = {
  classes: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired
}

TaskTable.defaultProps = {
  items: []
};


const mapDispatchToProps = {
  startEditBidEditorState,
  startRemoveTaskLaborItem,
  startRemoveTaskMaterialsItem
}

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps)
)(TaskTable);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Detail/TaskTable.jsx